module.exports = __webpack_public_path__ + "static/img/book11.042a2da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/book11.jpg
// module id = XPWc
// module chunks = 1